import { derived, get } from "svelte/store";
import isNumeric from "../utils/isNumeric.js";

// import rawCalculatorData from "../../public/df_assets/data/calculatorData.csv";
import { rawCalculatorData } from "./rawData.js";

// export const planData = readable({}, (set) => {
//   const formattedPlanData = rawPlanData.map((plan) => {
//     const columns = Object.keys(plan);

//     columns.forEach((column) => {
//       if (isNumeric(plan[column])) plan[column] = +plan[column];
//     });

//     plan["Plan_Type"] = plan["Plan_Type"].replace(
//       /(^\w{1})|(\s+\w{1})/g,
//       (letter) => letter.toUpperCase()
//     );

//     return plan;
//   });

//   set(formattedPlanData);
// });

export const calculatorData = derived(
  [rawCalculatorData],
  ([$rawCalculatorData]) => {
    if (!$rawCalculatorData) return null;

    const planIds = [
      ...new Set($rawCalculatorData.map((row) => row.equableclassid)),
    ];
    const planIdsData = {};
    planIds.forEach((id) => {
      const d = $rawCalculatorData.filter((row) => row.equableclassid === id);
      planIdsData[id] = d;
    });

    const formattedCalculatorData = $rawCalculatorData.map((row) => {
      const columns = Object.keys(row);

      columns.forEach((column) => {
        if (isNumeric(row[column])) row[column] = +row[column];
      });

      const planIdData = planIdsData[row.equableclassid];

      row["plantype"] = getPlanType(row["plantype"]);
      row["calculated_replacement_rate"] = getReplacementRate(planIdData, row);

      return row;
    });

    console.log("done");

    return formattedCalculatorData;
  }
);

function getPlanType(type) {
  if (type === "DC") return "Defined Contribution Plan";
  if (type === "GR") return "Guaranteed Return Plan";
  if (type === "Hybrid") return "Hybrid Plan";
  if (type === "FAS") return "Traditional Pension Plan";
  return "Unknown Plan Type";
}

function getReplacementRate(data, row) {
  const multiplierType = row["retroactive_multiplier"];

  if (multiplierType === 1) {
    return row["YOS"] * row["multiplier"];
  } else {
    const applicableData = data.filter((_row) => {
      return +_row["YOS"] <= +row["YOS"] && +_row["YOS"] !== 0;
    });

    //const applicableData = [{ multiplier: 2 }, { multiplier: 2 }];

    if (!applicableData) return 0;

    const sum = applicableData.reduce(function (previous, current) {
      return previous + +current["multiplier"];
    }, 0);

    return sum;
  }
}
